export default __webpack_public_path__ + "static/media/Helm of Violent Rage.e671eced.jpg";